/**
 * Zasłona w stylu STAREJ wersji (szare kręcące się kółko) na czas ładowania
 * zrzutu — żeby nowy wygląd nie mignął przed rozbiórką. Kolory celowo spoza
 * tokenów: to ma wyglądać jak stara aplikacja, nie jak nowa.
 */
export const OLD_BG = { light: '#f7f5f0', dark: '#1b1b1d' } as const;

export function OldLoadingCover({ dark }: { dark: boolean }) {
  return (
    <div
      className="fixed inset-0 z-[110] grid place-items-center"
      style={{ background: dark ? OLD_BG.dark : OLD_BG.light }}
    >
      <div
        className="h-8 w-8 animate-spin rounded-full border-2"
        style={{
          borderColor: dark ? '#3a3a3e' : '#d6d3cc',
          borderTopColor: dark ? '#9a9aa0' : '#6b6760',
        }}
      />
    </div>
  );
}
